import { Heading, HStack, Link } from '@chakra-ui/react'
import { RightArrowIcon } from '@!/components/Icon'

export const SectionTitle = ({ title, url, tabName }) => {
  return (
    <HStack spacing={0} mb={3}>
      <Heading fontSize="md" as="h2" noOfLines={1} flex="1">
        {title}
      </Heading>
      {url && (
        <Link
          as="a"
          href={url}
          fontSize="sm"
          fontWeight="300"
          color="label.primary"
          textDecoration="none"
          {...(tabName && { 'data-gtm-click': `${tabName}_${title}_一覧` })}
        >
          一覧
          <RightArrowIcon ml={0.5} mb={0.5} />
        </Link>
      )}
    </HStack>
  )
}
